import React, { FC, ReactNode } from "react";
import {
  Hint,
  Label,
  LabelGroup,
  Row,
  Value,
  ValueGroup,
  V3KVRowTone,
} from "./KVRow.styled";

export type { V3KVRowTone };

export interface V3KVRowProps {
  label: string;
  value: ReactNode;
  /** Raises the value to 16px semibold; combine with `tone` to colour it. */
  emphasis?: boolean;
  tone?: V3KVRowTone;
  hint?: string;
  divider?: boolean;
  trailing?: ReactNode;
  testID?: string;
}

export const V3KVRow: FC<V3KVRowProps> = ({
  label,
  value,
  emphasis = false,
  tone = "default",
  hint,
  divider = true,
  trailing,
  testID,
}) => (
  <Row $divider={divider} data-testid={testID}>
    <LabelGroup>
      <Label>{label}</Label>
      {hint ? <Hint>{hint}</Hint> : null}
    </LabelGroup>
    <ValueGroup>
      <Value $tone={tone} $emphasis={emphasis}>
        {value}
      </Value>
      {trailing}
    </ValueGroup>
  </Row>
);
